import React from 'react';
import { AuthContext, AuthContextType } from '~/services';

export function useLocalStorageState<T>(name: string, def: T, isObject = false) {
    const { authenticated, setStoredItems } = React.useContext(AuthContext) as AuthContextType;
    let existing = localStorage.getItem(name);
    if (isObject && existing) {
        existing = JSON.parse(existing);
    }
    const [item, setItem] = React.useState<T>((existing as T) || def);
    React.useEffect(() => {
        setStoredItems((prev) => [...prev, name]);
    }, [name, setStoredItems]);

    // set item in localStorage on change
    React.useEffect(() => {
        if (authenticated) {
            localStorage.setItem(name, isObject ? JSON.stringify(item) : (item as string));
        }
    }, [authenticated, isObject, item, name]);

    // remove item from localStorage on logout
    React.useEffect(() => {
        if (!authenticated && name in localStorage) {
            localStorage.removeItem(name);
            setItem(def);
        }
    }, [authenticated, name, def]);

    return { item, setItem };
}
